import Accordion from 'b2b-ui-components-lib/lib/components/accordion';
import RadioGroup from 'b2b-ui-components-lib/lib/components/radioGroup';
import Button from 'b2b-ui-components-lib/lib/components/button';
import React, { useContext, useEffect, useState } from 'react';
import RoundLoader from 'b2b-ui-components-lib/lib/components/roundLoader';
import FileUpload from './fileUpload';
import './index.scss';
import {
  DEFAULT_TOAST_MSG,
  DOCUMENT_TYPE_ENUM,
  ERROR_TOAST,
  KDM_TOAST_MSG,
  MULTI_SITE_MODULE_ID,
  SUCCESS_TOAST,
  SUMMARY_AUTH_TOKEN,
  WARNING_TOAST
} from 'home/view/manage-feasibility/constants';
import { getFromSessionStorage } from 'common/utils/app.utils';
import { deleteDocumentsForSummary, fetchOrder, fetchOrderDetails, sendPhotoLinkAOI, sendQuotationAOI } from 'home/view/manage-feasibility/services';
import { getDefaultFiles } from './formControl';
import { getCurrentLead } from 'tokenGeneration/lead.util';
import UploadDocuments from './documents/upload-documents';
import CustomModalKdm from './customModalKdm';
import { AppContext } from 'App';
import KdmImage from './documents/kdm-image-card';
import CustomModalEmail from './customModalEmail';
import kdmDummyImage from '../kdmDetails/documents/kdm.svg';

function KdmDetails({
  order = {},
  setIsSaveBtnDisabled = false,
  updatedEmail = '',
  setUpdatedEmail = () => {},
  fetchOrderFn,
  kdmAccordionValidation,
  setKdmAccordionValidation,
  companyGstValidation
}) {
  const options = [
    { id: 'pan', displayName: 'Pan Card' },
    { id: 'aadhaar', displayName: 'Aadhaar Card' }
  ];

  const { toast, setToast } = useContext(AppContext);

  const kdmInformation = order?.lead?.customer?.authorizedSignatory;
  const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

  const [form, setForm] = useState();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [imageFetchedValidation, setImageFetchedValidation] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [showEditPopUp, setShowEditPopUp] = useState(false);
  // const [reRenderComp, setReRenderComp] = useState(true);
  const [kdmInfo, setKdmInfo] = useState(kdmInformation);
  const [uploadedDoc, setUploadedDoc] = useState({});
  // const [updatedEmail, setUpdatedEmail] = useState(order?.lead?.customer?.authorizedSignatory?.email);
  const [kdmImagePresent, setKdmImagePresent] = useState(false);
  const [sendQuoatationModal, setSendQuoatationModal] = useState(false);
  const [kdmImageError, setKdmImageError] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  const summaryAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

  //   useEffect(() => {
  //     setDefaultFileArr(getDefaultFiles(order.documents));
  //   }, [order]);

  const KDM_TOAST = {
    show: true,
    message: 'Live photo of KDM is Mandatory.',
    type: 'warning',
    closeToastTime: '8000',
    eventHandler: null
  };

  // const handleKdmToast = () => {
  //   fetchOrderDetails(summaryAuthToken).then(
  //     (res) => {
  //       const livePhotoClicked = res?.res?.data?.result?.lead?.customer?.kdm;
  //       if (livePhotoClicked) {
  //         setToast(false);
  //       }
  //     },
  //     (error) => {
  //       console.log(error);
  //     }
  //   );
  // };

  // const reRenderComponent = () => {
  //   setReRenderComp(!reRenderComp);
  // };

  useEffect(() => {
    // console.log('re-rendered');
    // console.log(reRenderComp);
    // console.log(order);
    // fetchOrderFn();
    getDefaultSelectedOption();
    const hasKDMdoc = order?.documents?.AUTHORIZED_SIGNATORY?.hasOwnProperty('KDM');

    if (!hasKDMdoc) {
      setToast(true, KDM_TOAST.message, WARNING_TOAST);
    }
  }, []);

  const fileSchemaAadhaarCardFront = {
    supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
    maxFileLimit: 1024 * 1024,
    documentNames: ['AADHAAR_FRONT'],
    documentType: DOCUMENT_TYPE_ENUM.AUTHORIZED_SIGNATORY,
    allowMultiplePDFs: false
  };

  const fileSchemaAadhaarCardBack = {
    supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
    maxFileLimit: 1024 * 1024,
    documentNames: ['AADHAAR_BACK'],
    documentType: DOCUMENT_TYPE_ENUM.AUTHORIZED_SIGNATORY,
    allowMultiplePDFs: false
  };

  const fileSchemaPanCardFront = {
    supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
    maxFileLimit: 1024 * 1024,
    documentNames: ['PAN_FRONT'],
    documentType: DOCUMENT_TYPE_ENUM.AUTHORIZED_SIGNATORY,
    allowMultiplePDFs: false
  };
  const fileSchemaPanCardBack = {
    supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
    maxFileLimit: 1024 * 1024,
    documentNames: ['PAN_BACK'],
    documentType: DOCUMENT_TYPE_ENUM.AUTHORIZED_SIGNATORY,
    allowMultiplePDFs: false
  };

  // const fileSchemaVoterCard = {
  //   supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
  //   maxFileLimit: 1024 * 1024,
  //   documentNames: ['VOTER_CARD_FRONT', 'VOTER_CARD_BACK'],
  //   documentType: DOCUMENT_TYPE_ENUM.AUTHORIZED_SIGNATORY,
  //   allowMultiplePDFs: true
  // };

  // const fileSchemaDrivingLicense = {
  //   supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
  //   maxFileLimit: 1024 * 1024,
  //   documentNames: ['DL_FRONT', 'DL_BACK'],
  //   documentType: DOCUMENT_TYPE_ENUM.AUTHORIZED_SIGNATORY,
  //   allowMultiplePDFs: true
  // };

  const onSuccessCb = (order) => {
    // uploadedDocsObj(order);
    setUploadedDoc({});
  };

  const fetchKdmLiveImageHandler = async () => {
    const { res, err } = await fetchOrder(orderAuthToken);

    if (res) {
      const authSignatory = res?.data?.result?.documents?.AUTHORIZED_SIGNATORY;
      const kdmLiveImage = authSignatory && authSignatory['KDM'];
      if (kdmLiveImage) {
        setKdmImagePresent(true);
        setKdmImageError(false);
      } else {
        setKdmImageError(true);
      }
    } else if (err) {
    }
  };

  const getDefaultSelectedOption = () => {
    const docs = order?.documents?.AUTHORIZED_SIGNATORY;
    if (docs && docs['KDM']) {
      setKdmImagePresent(true);
      setKdmImageError(false);
    }
    if (docs) {
      const obj = {};
      Object.keys(docs).forEach((item) => {
        if (item !== 'KDM') {
          obj[item] = docs[item];
        }
      });
      if (Object.keys(obj)?.length === 0) {
        setSelectedOption(options[0]);
      } else {
        const docsType = Object.keys(obj)[0]?.split('_')[0];
        if (docsType === 'PAN') {
          setSelectedOption(options[0]);
        } else {
          setSelectedOption(options[1]);
        }
      }
    }
  };

  const onFileUpload = (files, type, uploadedFiles) => {
    setForm({ ...form, files });
    if (files) {
      setUploadedFiles(uploadedFiles);
    } else {
      setUploadedFiles([]);
    }
  };

  const uploadedDocsObj = (orderDetails) => {
    console.log(order);
    const authSignDocs = orderDetails?.documents?.AUTHORIZED_SIGNATORY || order?.documents?.AUTHORIZED_SIGNATORY;
    const obj = {};
    Object.keys(authSignDocs).forEach((item) => {
      if (item !== 'KDM') {
        obj[item] = authSignDocs[item];
      }
    });
    setUploadedDoc(obj);
  };

  const handleKDMEditSuccess = (orderRes) => {
    setUpdatedEmail(orderRes?.lead?.customer?.authorizedSignatory?.email);
  };

  const onChange = (value) => {
    setSelectedOption(value);
    const doc = uploadedDoc;
    setUploadedDoc({});
    // console.log(order, "onchange")
    const docsType = Object.keys(doc)[0]?.split('_')[0];
    // console.log(value, docsType, 'delete');
    if (value.id === 'aadhaar' && docsType === 'PAN') {
      deleteUploadedFiles('PAN_FRONT');
    } else if (value.id === 'pan' && docsType === 'AADHAAR') {
      deleteUploadedFiles('AADHAAR_FRONT');
      deleteUploadedFiles('AADHAAR_BACK');
    }
    // fetchOrderFn(null, summaryAuthToken, onSuccessCb);
    setKdmAccordionValidation(false);
    setIsSaveBtnDisabled(true);
    // setUploadedDoc({});
  };

  const deleteUploadedFiles = async (documentName) => {
    const payload = { documentType: 'AUTHORIZED_SIGNATORY', documentName };
    try {
      const { res, err } = await deleteDocumentsForSummary(payload, summaryAuthToken);
      if (res) {
        console.log('deleted successfully');
      }
    } catch (e) {
      console.error(e);
    }
  };

  // const deleteUploadedFile = () => {
  //   const summaryAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

  //   Array.isArray(uploadedFiles) &&
  //     uploadedFiles.forEach(async (_, index) => {
  //       const documentName = fileSchema.documentNames[index];
  //       const payload = { documentType: fileSchema.documentType, documentName };

  //       try {
  //         const { res, err } = await deleteDocumentsForSummary(payload, summaryAuthToken);

  //         if (res) {
  //           setUploadedFiles([]);
  //           setDefaultFileArr([]); // clear default files also after checkbox unchecked in PO details form
  //         } else if (err) {
  //           const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

  //           setToast(true, errorMsg, ERROR_TOAST);

  //           throw new Error(errorMsg);
  //         }
  //       } catch (e) {
  //         console.error(e);
  //       }
  //     });
  // };

  const handleEditKdmDetails = () => {
    // console.log('edit clicked');
    setShowEditPopUp(true);
  };

  // const fetchOrderFn = async (order_token = summaryAuthToken) => {
  //   try{
  //     const {res, err} = await fetchOrder(summaryAuthToken);
  //     if(res){
  //       const {data: {success = false, result = {}} } = res;

  //       if(success)
  //       {

  //       }
  //     }

  //   }
  //   catch{

  //   }
  // }

  const onSendQuoteClick = async () => {
    setSendQuoatationModal(true);
    console.log('quotation clicked');
    // try {
    //   const request = { email: [updatedEmail] };
    //   const { res, err } = await sendQuotationAOI(request, orderAuthToken);
    //   if (res) {
    //     const message = res?.data?.result;
    //     setToast(true, `Quote sent successfully to email: ${updatedEmail}`, SUCCESS_TOAST);
    //     scrollTo(0, 0);
    //   } else if (err) {
    //     const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

    //     setToast(true, errorMsg, ERROR_TOAST);
    //     throw new Error(errorMsg);
    //   }
    // } catch (e) {
    //   console.error(e);
    // }
  };

  const onSendPhotoLink = async () => {
    setShowLoader(true);
    console.log('photo clicked');
    try {
      const request = {};
      const orderAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
      const { res, err } = await sendPhotoLinkAOI(request, orderAuthToken);
      if (res) {
        setShowLoader(false);
        const message = res?.data?.status?.message;
        setToast(true, `Link sent successfully to email: ${updatedEmail}`, SUCCESS_TOAST);
        scrollTo(0, 0);
      } else if (err) {
        setShowLoader(false);
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      setShowLoader(false);
      console.error(e);
    }
  };

  return (
    <React.Fragment>
      {/* <h1>Choose a Billing Account to get the billing related details or enter the required details manually.</h1> */}
      {showEditPopUp && (
        <div>
          <CustomModalKdm
            fetchOrderFn={fetchOrderFn}
            kdmInfo={kdmInfo}
            setKdmInfo={setKdmInfo}
            // reRenderComponent={reRenderComponent}
            order={order}
            customPopupTitle="Update KDM Details"
            customPopupMsg
            // submitCustomPopup={handleGotoPlanPricingPage}
            closeCustomPopup={() => setShowEditPopUp(false)}
            onUpdateSuccess={handleKDMEditSuccess}
            // isLoading={showLoader}
          />
        </div>
      )}
      {sendQuoatationModal && (
        <div>
          <CustomModalEmail
            kdmInfo={kdmInfo}
            order={order}
            customPopupTitle="Send Quotation"
            closeCustomPopup={() => setSendQuoatationModal(false)}
            orderAuthToken={orderAuthToken}
            updatedEmail={updatedEmail}
          />
        </div>
      )}
      <Accordion title="KDM DETAILS" isValidated={kdmAccordionValidation} isExpanded={true} autoScrollOnExpand={false}>
        <div className="accordion_body">
          <div className="form_area">
            <div className="kdm-info row">
              <div className="flg-lg-9 flg-md-12">
                <p className="kdm-text">
                  <b
                    style={{
                      fontWeight: 700
                    }}
                  >
                    Name
                  </b>{' '}
                  : {kdmInfo?.firstName + ' ' + kdmInfo?.lastName}
                </p>
                <p className="kdm-text">
                  <b
                    style={{
                      fontWeight: 700
                    }}
                  >
                    Phone Number
                  </b>
                  : {kdmInfo?.phoneNumber}
                </p>
                <p className="kdm-text">
                  <b
                    style={{
                      fontWeight: 700
                    }}
                  >
                    Email
                  </b>
                  : {kdmInfo?.email}{' '}
                  <span className="links kdm-text" style={{ marginTop: '10px', fontSize: '15px' }} onClick={handleEditKdmDetails}>
                    <i class="aeh-icon-outlined-edit"></i>
                  </span>
                </p>
              </div>
              <div className="flg-lg-3 flg-md-12">
                {kdmImagePresent && <KdmImage order={order} />}
                {!kdmImagePresent && (
                  <div
                    style={{
                      paddingLeft: '15px'
                    }}
                  >
                    <img src={kdmDummyImage} width="80px" height="80px" />
                  </div>
                )}
                <div>
                  <span
                    onClick={fetchKdmLiveImageHandler}
                    style={{
                      textDecoration: 'underline',
                      cursor: 'pointer'
                    }}
                  >
                    Fetch KDM Image
                  </span>
                  {kdmImageError && (
                    <p
                      style={{
                        color: 'red'
                      }}
                    >
                      {' '}
                      *Image not Found
                    </p>
                  )}
                </div>
              </div>
            </div>

            <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#0c0f12' }} className="b2b-lib-heading">
              Choose a document to upload for KYC
            </h4>
            <div style={{ display: 'flex' }}>
              <p className="links" style={{ marginBottom: '20px', marginTop: '20px', fontSize: '16px' }}>
                <Button onClick={onSendPhotoLink} disabled={showLoader}>
                  Send Link for KDM photo
                </Button>
              </p>
              <p className="links" style={{ marginLeft: '10px', marginBottom: '20px', marginTop: '20px', fontSize: '16px' }}>
                <Button onClick={onSendQuoteClick}> Send Quotation</Button>
              </p>
              {showLoader && (
                <div className="links" style={{ height: '30px', width: '30px', marginLeft: '10px', marginBottom: '20px', marginTop: '20px' }}>
                  <RoundLoader />
                </div>
              )}
            </div>
            <div
              style={{
                marginBottom: '25px',
                color: 'red'
              }}
            >
              * User will not be allowed to proceed until KDM Live Photo has been captured , Use Send Link option to receive the link and capture KDM photo.
            </div>
            <div className="row field_row">
              <div className="flg-lg-12 flg-md-12">
                <div>
                  <RadioGroup options={options} value={selectedOption} onChange={onChange} />
                </div>
                {/* <div>
                  <ul>Supported file format is .PDF, .PNG, .JPG</ul>
                  <ul>Maximum file size is 1 Mb</ul>
                </div> */}
                {/* <div>
                    <input type="file" onChange={handleFileChange} />
                    <button onClick={handleUpload}>Upload</button>
                </div> */}
                <div className="radio-btn">
                  <UploadDocuments
                    fetchOrderFn={fetchOrderFn}
                    uploadedDoc={uploadedDoc}
                    setUploadedDoc={setUploadedDoc}
                    order={order}
                    selectedDocumentType={selectedOption}
                    setSelectedOption={setSelectedOption}
                    options={options}
                    setKdmAccordionValidation={setKdmAccordionValidation}
                    kdmImagePresent={kdmImagePresent}
                    setIsSaveBtnDisabled={setIsSaveBtnDisabled}
                    companyGstValidation={companyGstValidation}
                  />
                </div>
                {/* showing pan car schema */}
                {/* {selectedOption?.id === 'pan' && (
                  <>
                    <FileUpload
                      setKdmAccordionValidation
                      onFileUploadSuccess={onFileUpload}
                      label="Upload Pan Card Front"
                      // supportedLabel="Supported file format is .PDF, .PNG, .JPG"
                      // limitLabel="Maximum file size is 1 Mb"
                      fileSchema={fileSchemaPanCardFront}
                      isFileHaveValue={form && form.files && form.files.length > 0 ? true : false}
                      fileArray={form && form.files}
                      isOrderConfirmation={isOrderConfirmation}
                      multiple={false}
                    ></FileUpload>

                    <FileUpload
                      setKdmAccordionValidation
                      onFileUploadSuccess={onFileUpload}
                      label="Upload Pan Card Back"
                      // supportedLabel="Supported file format is .PDF, .PNG, .JPG"
                      // limitLabel="Maximum file size is 1 Mb"
                      fileSchema={fileSchemaPanCardBack}
                      isFileHaveValue={form && form.files && form.files.length > 0 ? true : false}
                      fileArray={form && form.files}
                      isOrderConfirmation={isOrderConfirmation}
                      multiple={false}
                    ></FileUpload>
                  </>
                )} */}

                {/* showing aadhaar card schema */}
                {/* {selectedOption?.id === 'aadhaar' && (
                  <>
                    <FileUpload
                      setKdmAccordionValidation
                      onFileUploadSuccess={onFileUpload}
                      label="Upload Aadhaar Card Front"
                      // supportedLabel="Supported file format is .PDF, .PNG, .JPG"
                      // limitLabel="Maximum file size is 1 Mb"
                      fileSchema={fileSchemaAadhaarCardFront}
                      isFileHaveValue={form && form.files && form.files.length > 0 ? true : false}
                      fileArray={form && form.files}
                      isOrderConfirmation={isOrderConfirmation}
                      multiple={false}
                    ></FileUpload>

                    <FileUpload
                      setKdmAccordionValidation
                      onFileUploadSuccess={onFileUpload}
                      label="Upload Aadhaar Card Back"
                      // supportedLabel="Supported file format is .PDF, .PNG, .JPG"
                      // limitLabel="Maximum file size is 1 Mb"
                      fileSchema={fileSchemaAadhaarCardBack}
                      isFileHaveValue={form && form.files && form.files.length > 0 ? true : false}
                      fileArray={form && form.files}
                      isOrderConfirmation={isOrderConfirmation}
                      multiple={false}
                    ></FileUpload>
                  </>
                )} */}

                {/* showing voter ID card schema */}
                {/* {selectedOption?.id === 'voter' && (
                  <FileUpload
                    setKdmAccordionValidation
                    onFileUploadSuccess={onFileUpload}
                    label="Upload voter ID Document (front, back)"
                    supportedLabel="Supported file format is .PDF, .PNG, .JPG"
                    limitLabel="Maximum file size is 1 Mb"
                    fileSchema={fileSchemaVoterCard}
                    isFileHaveValue={form && form.files && form.files.length > 0 ? true : false}
                    fileArray={form && form.files}
                    isOrderConfirmation={isOrderConfirmation}
                    multiple={true}
                  ></FileUpload>
                )} */}

                {/* showing driving license schema */}
                {/* {selectedOption?.id === 'dl' && (
                  <FileUpload
                    setKdmAccordionValidation={setKdmAccordionValidation}
                    onFileUploadSuccess={onFileUpload}
                    label="Upload driving license Document (front, back)"
                    supportedLabel="Supported file format is .PDF, .PNG, .JPG"
                    limitLabel="Maximum file size is 1 Mb"
                    fileSchema={fileSchemaDrivingLicense}
                    isFileHaveValue={form && form.files && form.files.length > 0 ? true : false}
                    fileArray={form && form.files}
                    isOrderConfirmation={isOrderConfirmation}
                    multiple={true}
                  ></FileUpload>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </Accordion>
    </React.Fragment>
  );
}

export default KdmDetails;
